import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { MyaccountB2bunitService } from 'src/app/service/myaccount/myaccount-b2bunit.service';

@Component({
  selector: 'app-request-deletion-modal',
  templateUrl: './request-deletion-modal.component.html',
  styleUrls: ['./request-deletion-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RequestDeletionModalComponent implements OnInit {
  payload: any;

  constructor(
    protected modalService: StandardModalService,
    private myAccountB2BUnitService: MyaccountB2bunitService,
    private messageService: GlobalMessageService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.payload = res.payload;
      });
  }

  ngOnInit() {}

  onRequestDeleteAccount() {
    this.postRequestDelete()
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          if (typeof res !== 'undefined') {
            for (const key in res) {
              if (key === 'requestedForDeletion') {
                if (res[key]) {
                  this.closeModal({ requestedForDeletion: true });
                  break;
                }
              }
            }
          }
          this.showGlobalMessage(
            'personalInfo.requestDeleteAcct.successMessage',
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
        },
        (err) => {
          this.closeModal('Cross click');
        }
      );
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  private postRequestDelete(): Observable<any> {
    return this.myAccountB2BUnitService.requestDeleteAccount(this.payload);
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }
}
